export default __webpack_public_path__ + "static/media/cataracts2.be0cc190.jpg";